"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newLine = exports.endEntryBlock = exports.endSubsection = exports.endSection = exports.endDocument = exports.subtitle = exports.sectionTitleContent = exports.dateContent = exports.textContent = exports.markdownContent = exports.numberContent = exports.booleanContent = exports.fileContent = exports.documentTitleContent = exports.renderDefaultArray = exports.defaultContent = void 0;
const utils = require("../utils");
const debug_1 = require("debug");
// const debugLog = debug('reporting:info');
// const verboseLog = debug('reporting:verbose');
// const errorLog = debug('reporting:error');
const warnLog = (0, debug_1.default)('reporting:warning');
const FALLBACK_VALUE = '-';
function defaultContent(data) {
    let content;
    if (data == undefined)
        return FALLBACK_VALUE;
    if (typeof data === 'boolean') {
        content = booleanContent(data);
    }
    else if (typeof data === 'number') {
        content = numberContent(data);
    }
    else if (typeof data === 'string') {
        content = textContent(data);
    }
    else if (data instanceof Date) {
        content = dateContent(data);
    }
    else if (typeof data === 'object') {
        if ('type' in data) {
            if (data.type === 'markdown') {
                content = markdownContent(data.text);
            }
            else if (data.type === 'title') {
                content = documentTitleContent(data.text);
            }
            else if (data.type === 'text') {
                content = textContent(data.text);
            }
            else {
                throw new Error(`Invalid subsection type of ${data.type} with data ${JSON.stringify(data)}`);
            }
        }
        else if ('url' in data) {
            content = fileContent(data);
        }
        else {
            content = Object.keys(data).map((key) => [
                key,
                defaultContent(data[key]),
            ]);
        }
    }
    else if (Array.isArray(data)) {
        if (data.length > 0 && typeof data[0] === 'object' && 'url' in data[0]) {
            // An array of files
            if (data.length === 1) {
                content = fileContent(data[0], 'Link');
            }
            else {
                const subcontent = [];
                for (let i = 0; i < data.length; i++) {
                    subcontent.push(fileContent(data[i], `Link ${i + 1}`));
                    subcontent.push(', ');
                }
                content = {
                    text: subcontent,
                    style: 'defaultContentArray',
                };
            }
        }
        else {
            content = data.map((datum) => defaultContent(datum));
        }
    }
    else {
        warnLog(`In makeSubsectionContent, received data with value ${JSON.stringify(data)}.`);
        if (typeof data === 'object' && 'url' in data) {
            content = JSON.stringify(data);
        }
        else {
            content = data.toString();
        }
    }
    return content != undefined ? content : FALLBACK_VALUE;
}
exports.defaultContent = defaultContent;
function renderDefaultArray(data) {
    const subcontent = [];
    for (const datum of data) {
        subcontent.push(defaultContent(datum));
        subcontent.push(' ');
    }
    return {
        text: subcontent,
        style: 'defaultContentArray',
    };
}
exports.renderDefaultArray = renderDefaultArray;
function documentTitleContent(content) {
    return {
        text: content,
        style: 'documentTitle',
    };
}
exports.documentTitleContent = documentTitleContent;
function fileContent(file, placeholder) {
    // if (file.format === "image") {
    // 	todo embed the image
    // }
    return {
        text: placeholder || 'link',
        link: file.url,
        style: 'link',
    };
}
exports.fileContent = fileContent;
function booleanContent(content) {
    return {
        text: content ? 'Yes' : 'No',
        style: 'boolean',
    };
}
exports.booleanContent = booleanContent;
function numberContent(content) {
    return {
        text: content.toString(),
        style: 'number',
    };
}
exports.numberContent = numberContent;
function markdownContent(content) {
    // content = contentToMarkDown(content); // TODO
    return {
        text: content,
        style: 'markdown',
    };
}
exports.markdownContent = markdownContent;
function textContent(content) {
    return {
        text: content,
        style: 'text',
    };
}
exports.textContent = textContent;
function dateContent(content) {
    const results = utils.dateToString(content);
    return {
        text: results,
        style: 'date',
    };
}
exports.dateContent = dateContent;
function sectionTitleContent(content) {
    return {
        text: content,
        style: 'sectionTitle',
    };
}
exports.sectionTitleContent = sectionTitleContent;
function subtitle(text) {
    return {
        text,
        style: 'subtitle',
    };
}
exports.subtitle = subtitle;
function endDocument() {
    return {
        text: 'This document was generated by Aetonix',
        style: 'endDocument',
    };
}
exports.endDocument = endDocument;
function endSection() {
    return {
        lineHeight: 2,
        canvas: [{ type: 'line', x1: 0, y1: 10, x2: 450, y2: 10, lineWidth: 1 }],
        style: 'endSection',
    };
}
exports.endSection = endSection;
function endSubsection() {
    return {
        lineHeight: 1,
        canvas: [{ type: 'line', x1: 0, y1: 10, x2: 50, y2: 10, lineWidth: 1 }],
        style: 'endSubsection',
    };
}
exports.endSubsection = endSubsection;
function endEntryBlock() {
    return {
        lineHeight: 5,
        text: '',
        style: 'endEntry',
    };
}
exports.endEntryBlock = endEntryBlock;
function newLine() {
    return '\n';
}
exports.newLine = newLine;
//# sourceMappingURL=content.js.map